<template>
  <div class="step-wrapper container">
    <b-row>
      <b-col>
        <div class="step-wrapper-subject"><strong>step 7 | Qty</strong></div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="step-wrapper-description mt-4">
          How many would you like to order?
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-link class="more-info mt-4 mb-4" v-b-modal.modal-discount>View Discount Chart</b-link>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col cols="12">
        <b-form-input
          v-model="stencileaseQty"
          type="number"
          placeholder=""
          min="1"
          @change.native="changeQty"
          @click.native="changeQty"
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="stencilform-price-box stencilform--hide">
      <div class="col-sm-7 col-9">Characters per Material:</div>
      <div class="col-sm-5 col-3 stencilform-price-box-lineitem">
        <strong>{{ stencilTextLen }}</strong>
      </div>
    </b-row>

    <b-row class="stencilform-price-box stencilform--hide">
      <div class="col-sm-7 col-7">Total Characters:</div>
      <div class="col-sm-5 col-5 stencilform-price-box-lineitem">
        <strong>{{ stencilTotalLen }}</strong>
      </div>
    </b-row>

    <b-row>
      <b-col cols="12">
        <label style="font-size:1.3em; font-weight:bold; color: #be4141;">
          Special instructions
        </label>
        <b-form-textarea
          :value="instructions"
          @input.native="updateInstructions"
          placeholder="Special instructions for this item"
          :rows="3"
          :max-rows="6"
        >
        </b-form-textarea>
      </b-col>
    </b-row>

    <b-row v-if="instructions">
      <b-col cols="12">
        <b-form-checkbox
          :value="requiresEmailPreview"
          @change="updateRequiresEmailPreview"
          value="Yes"
          unchecked-value="No"
        >
          <span style="color: #000; font-weight: bold; font-size:1.3em;">
            I'd like to receive an email preview of the work.
          </span>
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="stencilform-price-box">
      <div class="col-sm-6 col-6">Total Price:</div>
      <div class="col-sm-6 col-6 stencilform-price-box-lineitem">
        $ <strong>{{ stencilPrice }}</strong>
      </div>
    </b-row>

    <b-button
      variant="default"
      class="go-next go-add-to-cart"
      :disabled="cartDisabled"
      v-on:click="add_to_cart">
      Add to cart
    </b-button>

    <b-modal id="modal-discount" size="md" title="Quantity Discount" hide-footer>
      <div v-html="discountTexts"></div>
    </b-modal>
  </div>
</template>

<script>
import jQuery from 'jquery';
import axios from 'axios';
import { STENCILCONST } from '../modules/constant.js.erb';
// The backend server URL
const APP_URL = process.env.APP_URL;

export default {
  data() {
    return {
      stencileaseQty: '1',
    };
  },
  computed: {
    discountTexts: function() {
      return this.$store.state.product.discountTexts;
    },
    products: function() {
      return this.$store.state.product.products;
    },
    fingerprint: function() {
      return Math.random()
        .toString(36)
        .substring(7);
    },
    borderSpacing: function() {
      return this.$store.getters['product/borderSpacing'];
    },
    textWidthInInches: function() {
      return this.$store.getters['product/textWidthInInches'];
    },
    textHeightInInches: function() {
      return this.$store.getters['product/textHeightInInches'];
    },
    requiredHeight: function() {
      return this.$store.getters['product/materialHeight'];
    },
    requiredWidth: function() {
      return this.$store.getters['product/materialWidth'];
    },
    materialProducts: function() {
      const material = this.$store.state.product.material;
      const materialNameRegexp = new RegExp(
        `^${material} Material Charge for Custom Stencil`,
      );

      return (
        this.products.filter(
          (p) => p.title && p.title.search(materialNameRegexp) != -1,
        ) || []
      );
    },
    stencilWidth: function() {
      return this.fit(this.materialInfo.dimension_w, this.requiredWidth);
    },
    stencilHeight: function() {
      return this.fit(this.materialInfo.dimension_h, this.requiredHeight);
    },
    matchingMaterialVariant: function() {
      return this.materialProducts
        .map((p) => p.variants)
        .flat()
        .find((v) => v.option1 == `${this.stencilWidth}x${this.stencilHeight}`);
    },
    materialInfo: function() {
      return STENCILCONST.material.find(
        (info) => info.value == this.$store.state.product.material,
      );
    },
    textLength: function() {
      const length = this.$store.state.product.textBody.replace(/\s/g, '')
        .length;

      if (length < 3) {
        return 3;
      } else {
        return length;
      }
    },
    customStencilProduct: function() {
      const productName = `Cutting Charge for Custom Stencil - ${
        this.$store.state.product.material
      }`;
      const product = this.products.find(
        (p) => p.title && p.title.search(productName) != -1,
      );

      if (product) {
        return product;
      } else {
        console.log(`Couldn't find product: ${productName}`);
        return;
      }
    },
    customStencilVariant: function() {
      const th = this.$store.state.product.textHeight;
      // TODO Make this variant search match 2'' or 2 inches instead of the plain value
      const variant = this.customStencilProduct.variants.find(
        (p) => p.option1 == th,
      );

      if (variant) {
        return variant;
      } else {
        console.log(`Couldn't find material variant: ${th}`);
        return;
      }
    },
    stencilPrice: function() {
      return this.calculatePrice();
    },
    stencilTextLen: function() {
      return this.$store.state.product.textBody.replace(/\s/g, '').length;
    },
    stencilTotalLen: function() {
      return this.stencilTextLen * this.stencileaseQty;
    },
    cartDisabled: function() {
      return this.$store.state.product.textBody.replace(/\s/g, '').length == 0;
    },
    requiresEmailPreview: function() {
      return false;
    },
    instructions: function() {
      return this.$store.state.product.instructions;
    },
    requiresEmailPreview: function() {
      return this.$store.state.product.requiresEmailPreview;
    },
  },
  methods: {
    fit: function(elements, size) {
      size = size || 0;
      const sorted = elements.concat().sort((a, b) => a - b);
      return sorted.filter((e) => e >= size)[0] || sorted.slice(-1)[0];
    },
    updateRequiresEmailPreview: function(value) {
      this.$store.dispatch('product/SET_REQUIRES_EMAIL_PREVIEW', value);
    },
    updateInstructions(event) {
      this.$store.dispatch('product/SET_INSTRUCTIONS', event.target.value);
      event.preventDefault();
    },
    changeQty(evt) {
      if (this.stencileaseQty == '' || parseInt(this.stencileaseQty) == 0) {
        this.stencileaseQty = 1;
      }
      this.stencileaseQty = parseInt(this.stencileaseQty);
      this.$store.dispatch('product/SET_QUANTITY', this.stencileaseQty);
      this.calculatePrice();
    },
    formatMoney(v, c, d, t) {
      var n = v,
        c = isNaN((c = Math.abs(c))) ? 2 : c,
        d = d == undefined ? '.' : d,
        t = t == undefined ? ',' : t,
        s = n < 0 ? '-' : '',
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return (
        s +
        (j ? i.substr(0, j) + t : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
        (c
          ? d +
            Math.abs(n - i)
              .toFixed(c)
              .slice(2)
          : '')
      );
    },
    calculatePrice() {
      const cutting_price = this.textLength * this.customStencilVariant.price;
      const material_price = parseFloat(this.matchingMaterialVariant.price);
      const first_copy_price = cutting_price + material_price;
      const qty = parseInt(this.stencileaseQty);

      const copyPercentDiscount = (copy_no, discount_table) => {
        const range = _(copy_no)
          .times()
          .map((i) => i + 1)
          .reverse();
        const breakpoint = _(range).find(
          (r) => !_.isUndefined(discount_table[r]),
        );
        return discount_table[breakpoint] || 0;
      };

      const discountedCopy = (copy_no, base_price, discount_table) => {
        return (
          ((100 - copyPercentDiscount(copy_no, discount_table)) / 100) *
          base_price
        );
      };

      const discounted_items = _(qty).times((i) =>
        discountedCopy(
          i + 1,
          first_copy_price,
          this.$store.getters['product/discountSchedule'],
        ),
      );

      let total_price = _(discounted_items).sum();
      this.$store.dispatch(
        'product/SET_TOTALPRICE',
        this.roundTwoDecimals(total_price),
      );
      return this.formatMoney(total_price);
    },
    roundTwoDecimals: function(number) {
      return Math.floor(number * 100) / 100;
    },
    add_to_cart() {
      const material = this.$store.state.product.material;
      let qty = this.$store.state.product.quantity * this.textLength;

      if (this.customStencilVariant != null) {
        let params = {
          id: this.customStencilVariant.id,
          quantity: qty,
          properties: {
            'Material Width': this.requiredWidth.toFixed(2) + ' inches',
            'Material Height': this.requiredHeight.toFixed(2) + ' inches',
            'Capital Text Height':
              this.$store.state.product.textHeight + ' inches',
            'Overall Text Width': this.textWidthInInches.toFixed(2) + ' inches',
            'Overall Text Height':
              this.textHeightInInches.toFixed(2) + ' inches',
            Text: this.$store.state.product.textBody,
            Font: this.$store.state.product.textFont,
            'Text Align': this.$store.state.product.textAlign,
            Copies: this.$store.state.product.quantity,
            'Material Variant': 'No. ' + this.matchingMaterialVariant.id,
            Material: material,
            'Special Instructions': this.$store.state.product.instructions,
            'Email Work Preview': this.$store.state.product
              .requiresEmailPreview,
            Fingerprint: this.fingerprint,
          },
        };

        axios
          .post('/cart/add.js', params)
          .then((response) => {
            axios
              .get('/cart.js')
              .then((response) => {
                let nparams = {
                  token: response.data.token,
                  variant_id: this.customStencilVariant.id,
                  hmac: __se_hmac,
                  img: STENCILCONST._svg,
                  svg_w: STENCILCONST._svg_w,
                  svg_h: STENCILCONST._svg_h,
                  shop: shop_domain,
                  fingerprint: this.fingerprint,
                  border_spacing_inches: this.borderSpacing,
                  text_height_in_points: this.$store.getters[
                    'product/referenceTextHeight'
                  ],
                  text_height_in_inches: this.$store.state.product.textHeight,
                };

                axios
                  .post(APP_URL + '/api/image_on_cart', nparams)
                  .then((response) => {
                    let params_material = {
                      id: this.matchingMaterialVariant.id,
                      quantity: this.stencileaseQty,
                      properties: {
                        Material: material,
                        Copies: this.$store.state.product.quantity,
                        Fingerprint: this.fingerprint,
                      },
                    };
                    axios
                      .post('/cart/add.js', params_material)
                      .then((response) => {
                        location.href = '/cart';
                      })
                      .catch((e) => {
                        console.log(e);
                      });
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
  },
};
</script>
